import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { logout } from "../../services/authService";
import { HOTELSRIVER_OFFICIAL_LOGO_URL as Logo } from "../../utils/hotelsRiverBrandLogo";
import { ROUTE_IDS } from "../routeIds";
import { useDashboardNavigate } from "../hooks/useDashboardNavigate";
import { useProductContext } from "../providers/ProductContextProvider";
import { traceHotelSearchOnly, traceInternationalShell } from "../routeTelemetry";
import "./InternationalDashboardLayout.scss";

export function InternationalDashboardLayout({ children }) {
  const { t } = useTranslation();
  const dashNav = useDashboardNavigate();
  const { locale } = useProductContext();

  React.useEffect(() => {
    traceInternationalShell({ locale, layout: "InternationalDashboardLayout" });
    traceHotelSearchOnly({ locale, scope: "hotel_search_only" });
  }, [locale]);

  const handleLogout = () => {
    logout();
    const loginPath = dashNav.pathFor(ROUTE_IDS.LOGIN);
    window.location.href = loginPath || "/login";
  };

  return (
    <div className="international-dashboard-layout" data-locale={locale} dir="ltr">
      <header className="international-dashboard-layout__header">
        <Tooltip title={t("sidenav.home", "Home")}>
          <button
            type="button"
            className="international-dashboard-layout__logo-btn"
            onClick={() => dashNav.to(ROUTE_IDS.HOTEL_SEARCH)}
          >
            <img src={Logo} alt="HotelsRiver" width={160} height={42} decoding="async" />
          </button>
        </Tooltip>
        <div className="international-dashboard-layout__actions">
          <button
            type="button"
            className="international-dashboard-layout__logout"
            onClick={handleLogout}
          >
            {t("sidenav.logout", "Logout")}
          </button>
        </div>
      </header>
      <main className="international-dashboard-layout__main">{children}</main>
    </div>
  );
}

export default InternationalDashboardLayout;
